import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

// Password Input Component
export const MiUiPasswordInput = ({
  label,
  value,
  onChange,
  name,
  error,
  helperText,
  disabled,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [inputValue, setInputValue] = useState(value || "");

  useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleMouseDown = (event) => {
    event.preventDefault(); // Prevent default focus behavior
  };

  const handleChange = (event) => {
    setInputValue(event.target.value);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <TextField
      type={showPassword && !disabled ? "text" : "password"}
      label={label}
      name={name}
      value={inputValue}
      onChange={handleChange}
      fullWidth
      variant="outlined"
      error={error}
      helperText={helperText}
      disabled={disabled}
      autoComplete="new-password"
      {...props}
      InputProps={
        !disabled && {
          endAdornment: (
            <>
              <InputAdornment position="end">
                <IconButton
                  onClick={handleTogglePasswordVisibility}
                  onMouseDown={handleMouseDown}
                  edge="end"
                  aria-label="toggle password visibility"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            </>
          ),
        }
      }
    />
  );
};

// Normal Input Component
export const MiUiNormalInput = ({
  label,
  value,
  onChange,
  name,
  error,
  helperText,
  ...props
}) => {
  return (
    <TextField
      type="text"
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      fullWidth
      variant="outlined"
      error={error}
      helperText={helperText}
      autoComplete="off"
      {...props}
    />
  );
};
